<template lang="pug">
.loader(:class="{error}")
  .loader__spinner
    span.loader__block
    span.loader__block
    span.loader__block
    span.loader__block
    span.loader__block
    span.loader__block
    span.loader__block
    span.loader__block
    span.loader__block
  h4.loader__copy(v-if="error")
    span(v-for="ch in error_array") {{ch}}
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'loader',
  data() {
    return {
      error_text: document.querySelector('#error_text').value,
    }
  },
  computed: {
    ...mapGetters(['get']),
    loading() {
      return this.get('loading')
    },
    error() {
      return this.get('error')
    },
    error_msg() {
      return this.get('error_msg')
    },
    error_array() {
      return this.error_msg ? this.error_msg : this.error_text.split('')
    },
  },
}
</script>

<style lang="scss" scoped>
// Play with these to see what you get
$delay: 0.065s;
$duration: 0.88s;

.loader {
  --startingColor: #{$midnight};
  --endingColor: #{$slate};
  min-height: 50vh;
  width: 100%;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.error {
    --startingColor: #{$error};
    --endingColor: #{$error};
  }

  &__spinner {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    height: 12rem;
    width: 12rem;
    gap: 1rem;
  }

  &__block {
    grid-area: span 1 / span 1;
    opacity: 0;
    background: var(--startingColor);
    animation: show $duration step-end infinite alternate, pulse $duration linear infinite alternate;
    .error & {
      animation-fill-mode: forwards, none;
      animation-iteration-count: 5, infinite;
    }
    &:nth-child(1) {
      animation-delay: 1 * $delay;
    }
    &:nth-child(2) {
      animation-delay: 2 * $delay;
    }
    &:nth-child(3) {
      animation-delay: 3 * $delay;
    }
    &:nth-child(4) {
      animation-delay: 5 * $delay;
    }
    &:nth-child(5) {
      animation-delay: 2 * $delay;
    }
    &:nth-child(6) {
      animation-delay: 7 * $delay;
    }
    &:nth-child(7) {
      animation-delay: 6 * $delay;
    }
    &:nth-child(8) {
      animation-delay: 4 * $delay;
    }
  }

  &__copy {
    max-width: 550px;
    margin-top: 3rem;
    line-height: 1.875;
    text-align: center;
    color: var(--endingColor);
    @include fluid(font-size, 1rem, 1.25rem);
    span {
      opacity: 0;
      animation: fadein 0.75s forwards ease;
      @for $i from 1 through 200 {
        &:nth-child(#{$i}) {
          animation-delay: $i * 0.0125s;
        }
      }
    }
  }
}

@keyframes pulse {
  from,
  40% {
    background: var(--startingColor);
  }
  to {
    background: var(--endingColor);
  }
}

@keyframes show {
  from,
  40% {
    opacity: 0;
  }
  41%,
  to {
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
